export default "__VITE_ASSET__f2a434ed__"